/*
Replace
nft with your resource Name :) Take care about different writings!
/!\ Nft nft Nfts nfts /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const navigationItemsSlice = createSlice({
  name: "navigationItems",
  initialState: { ...defaultInitialState, slugDictionary: {} },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
    updateErrorReset: (state, action) => {
      state.updating = false;
      state.updated = false;
      state.updateError = null;
    },
    listErrorReset: (state, action) => {
      state.listing = false;
      state.listed = false;
      state.listError = null;
    },
    createErrorReset: (state, action) => {
      state.creating = false;
      state.created = false;
      state.createError = null;
    },
    showErrorReset: (state, action) => {
      state.showing = false;
      state.showed = false;
      state.showError = null;
      state.unlockError = null;
      state.unlockSuccess = false;
    },
  },
});

export const {
  show: showNavigationItem,
  update: updateNavigationItem,
  list: listNavigationItems,
  create: createNavigationItem,
  updateErrorReset: updateNavigationItemErrorReset,
  listErrorReset: listNavigationItemErrorReset,
  createErrorReset: createNavigationItemErrorReset,
  showErrorReset: showNavigationItemErrorReset,
} = navigationItemsSlice.actions;
export const actions = navigationItemsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const navigationItems = (state) =>
  state.navigationItems.idsList.map(
    (id) => state.navigationItems.dictionary[id]
  );
export const navigationItem = (state) =>
  state.navigationItems.showId &&
  state.navigationItems.dictionary[state.navigationItems.showId];
export const navigationItemAttributes = (state) =>
  navigationItem(state)?.attributes;
export const navigationItemRelationships = (state) =>
  navigationItem(state)?.relationships;
export const navigationItemId = (state) => state.navigationItems.showId;

export const getNavigationItem = createSelector(
  (state) => state.navigationItems.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getNavigationItemAttributes = createSelector(
  (state) => state.navigationItems.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getNavigationItemRelationships = createSelector(
  (state) => state.navigationItems.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getNavigationItems = createSelector(
  (state) => state.navigationItems.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default navigationItemsSlice.reducer;
